import { PaymentService } from '@payment/services/payment.service';
import { ChangeDetectionStrategy, Component, forwardRef, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-select-payment-method-dialog',
    template: `
        <egov-dialog-close-button></egov-dialog-close-button>
        <div class="prevent-overlap-with-close-button"></div>
        <h2 mat-dialog-title>Select Payment Method</h2>
        <div class="select-payment-method-dialog">
            <div class="content">
                <app-payment-method-selection-list
                    [allowNoneOption]="true"
                    [selectedPaymentMethod]="selectedPaymentMethod"
                    [allowCreation]="true"
                    (selected)="selectMethod($event)"
                    (newMethodRequested)="newMethod()"
                ></app-payment-method-selection-list>
            </div>
        </div>
    `,
    styleUrls: ['./select-payment-method-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPaymentMethodDialogComponent
{
    constructor
    (

        // Dependencies

        @Inject(forwardRef(() => PaymentService)) private readonly service: PaymentService,


        // Dialog reference and passed data

        private readonly dialogRef: MatDialogRef<SelectPaymentMethodDialogComponent, string | null | undefined>,
        @Optional() @Inject(MAT_DIALOG_DATA) protected selectedPaymentMethod?: string,
    )
    {}


    // Actions

    protected selectMethod(method: string | null)
    {
        this.dialogRef.close(method);
    }

    protected newMethod()
    {
        this.service.openNewPaymentMethod().subscribe(method => this.selectMethod(method));
    }
}
